import React, { Component, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import setAuthToken from './utils/setAuthToken';
import { setCurrentUser } from './reducers/authReducer';
import { logoutUser } from './actions/authAction';

import axios from 'axios'
import { API_URL } from './actions/constant'


import { Provider } from 'react-redux';
import store from './store';
import './App.css';
import PrivateRoute from './components/common/PrivateRoute';
import { listSetting, setlanguage } from './reducers/crudReducer';

import Loader from "./components/common/Spinner"
import { Language } from './actions/language';

axios.defaults.baseURL = API_URL;



const Landing = React.lazy(() => import('./components/layouts/Landing'));


//ADMIN ROUTE
const AdminLogin = React.lazy(() => import('./components/admin/auth/Login'));
const AdminVerifyOtp = React.lazy(() => import('./components/admin/auth/VerifyOtp'));



const Dashboard = React.lazy(() => import('./components/admin/dashboard/Dashboard'));

const AddUser = React.lazy(() => import('./components/admin/user/add'));
const ListUser = React.lazy(() => import('./components/admin/user/list/List'));
const ViewUser = React.lazy(() => import('./components/admin/user/view/View'));



const ListCategory = React.lazy(() => import('./components/admin/category/list/List'));
const AddCategory = React.lazy(() => import('./components/admin/category/add'));
const ViewCategory = React.lazy(() => import('./components/admin/category/view/'));

const ListSlider = React.lazy(() => import('./components/admin/slider/list/List'));
const AddSlider = React.lazy(() => import('./components/admin/slider/add'));
const ViewSlider = React.lazy(() => import('./components/admin/slider/view/'));

const ListSponser = React.lazy(() => import('./components/admin/sponser/list/List'));
const AddSponser = React.lazy(() => import('./components/admin/sponser/add'));
const ViewSponser = React.lazy(() => import('./components/admin/sponser/view/'));


const AddEvent = React.lazy(() => import('./components/admin/event/add'));
const ListEvent = React.lazy(() => import('./components/admin/event/list/List'));
const ViewEvent = React.lazy(() => import('./components/admin/event/view/View'));









const AddSetting = React.lazy(() => import('./components/admin/setting/AddSetting'));


const ListNotification = React.lazy(() => import('./components/admin/notification/list/List'));
const AddNotification = React.lazy(() => import('./components/admin/notification/add'));
const ViewNotification = React.lazy(() => import('./components/admin/notification/view/'));


const ListTeam = React.lazy(() => import('./components/admin/team/list/List'));




const PaymentRedirect = React.lazy(() => import('./components/admin/payment/Redirect'));


const Privacy = React.lazy(() => import('./components/admin/privacy/'));
const Terms = React.lazy(() => import('./components/admin/terms/'));


store.dispatch(listSetting())



if (!localStorage.lang) {
  // axios.defaults.params = { lang: "en" };
  axios.defaults.headers.common['lang'] = "en";
  store.dispatch(setlanguage(Language["en"]))
} else {
  // axios.defaults.params = { lang: localStorage.lang };
  axios.defaults.headers.common['lang'] = localStorage.lang
  store.dispatch(setlanguage(Language[localStorage.lang]))
}











if (localStorage.jwtToken) {
  //Set Auth Token header Auth
  setAuthToken(localStorage.jwtToken);
  //Decode Token and get user info and exp
  const decoded = jwt_decode(localStorage.jwtToken);
  store.dispatch(setCurrentUser(decoded));
  //Check for expired token
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    //Logout user
    store.dispatch(logoutUser());
    //ToDO : clear current profile
    //Redirect to Login page
    window.location.href = '/login';
  }

}




export default function App() {

  var currentlayout = localStorage.lang === "ar" ? "rtl" : "ltr"

  return (
    <div dir={currentlayout}>


      <Provider store={store}>
        <Router
          exact
          path="/"
        >
          <Suspense fallback={<Loader />}>
            {/* <div class="nk-app-root"> */}
            {/* ADMIN ROUTE */}
            <Routes>
              <Route index exact path="/" element={<AdminLogin />} />
              <Route exact path="/payment/redirect" element={<PaymentRedirect />} />
              <Route exact path="/privacy" element={<Privacy />} />
              <Route exact path="/terms" element={<Terms />} />


              {/* //ADMIN ROUTE */}
              <Route index exact path="/admin/login" element={<AdminLogin />} />

              <Route index exact path="/admin/verifyotp" element={<AdminVerifyOtp />} />

              <Route path="/" element={<PrivateRoute />}>
                <Route index exact path="/admin/dashboard" element={<Dashboard />} />

                <Route index exact path="/admin/user/add" element={<AddUser />} />
                <Route index exact path="/admin/user/list" element={<ListUser />} />
                <Route index exact path="/admin/user/view/:id" element={<ViewUser />} />


                <Route index exact path="/admin/team/list" element={<ListTeam />} />



                <Route index exact path="/admin/category/list" element={<ListCategory />} />
                <Route index exact path="/admin/category/add" element={<AddCategory />} />
                <Route index exact path="/admin/category/view/:id" element={<ViewCategory />} />



                <Route index exact path="/admin/slider/list" element={<ListSlider />} />
                <Route index exact path="/admin/slider/add" element={<AddSlider />} />
                <Route index exact path="/admin/slider/view/:id" element={<ViewSlider />} />



                <Route index exact path="/admin/event/add" element={<AddEvent />} />
                <Route index exact path="/admin/event/list" element={<ListEvent />} />
                <Route index exact path="/admin/event/view/:id" element={<ViewEvent />} />





                <Route index exact path="/admin/sponser/list" element={<ListSponser />} />
                <Route index exact path="/admin/sponser/add" element={<AddSponser />} />
                <Route index exact path="/admin/sponser/view/:id" element={<ViewSponser />} />




                {/* <Route index exact path="/admin/notification/list" element={<ListNotification />} />
                <Route index exact path="/admin/notification/add" element={<AddNotification />} />
                <Route index exact path="/admin/notification/view/:id" element={<ViewNotification />} /> */}


                <Route index exact path="/admin/setting/" element={<AddSetting />} />

              </Route>



            </Routes>
            {/* </div> */}
          </Suspense>
        </Router>
      </Provider>
    </div>
  )
}
